// extracted by mini-css-extract-plugin
export default {"projectView-container":"ProjectPage_projectView-container__zoqPn","tabs-container":"ProjectPage_tabs-container__6D-K8","content-container":"ProjectPage_content-container__65xSq"};